export interface KeyValueProp {
  key?: string;
  value?: string;
}

export type ColorSetType = 'RED' | 'GREEN' | 'BLUE';

export interface Chart {
  title?: string;
  subTitle?: string;
  data?: KeyValueProp[];
  legend?: KeyValueProp[];
}

export const isObjectOfTypeMetaProduct = (data: any): data is MetaProduct => {
  return data.colorSet && (data.stage || data.productFeatures || data.productBenefit || data.productCertificates || data.additionalOptions || data.overview);
};

export interface ProductResultSets {
  business: string[];
  housingIndustry: string[];
  majorCustomers: string[];
}

export interface MetaProduct {
  colorSet?: ColorSetType;
  stage?: {
    fullName?: string;
    keyFeatures?: string[];
    stageImageId?: string;
    targetGroupsHint?: string;
  };
  productFeatures?: {
    title?: string;
    features?: {
      [key: string]: string;
    };
    requirements?: string[];
    termsOfPayment?: string;
    hint?: string;
    hintImageId?: string;
    pieCharts?: {
      title?: string;
      subTitle?: string;
      charts?: Chart[];
    };
  };
  productBenefit?: {
    title?: string;
    list?: string[];
    hint?: {
      title?: string;
      text: string[];
    };
  };
  productCertificates?: {
    title?: string;
    text?: string[];
    certificatesIds: string[];
  };
  additionalOptions?: {
    title?: string;
    list?: string[];
  };
  overview?:{
    title?: string;
    list?:string[];
  }
}

export interface Product {
  id: string;
  productCategoryId: string;
  name: string;
  displayName?: string;
  eco: boolean;
  description: string;
  type: string;
  metaProduct: MetaProduct;
  targetGroups: string[];
  attachments: string[];
  resultSets: ProductResultSets;
  leadQuestionnaires: string[];
}

export interface ProductCategory {
  id: string;
  name: string;
  description: string;
  createdAt: number;
  updatedAt: number;
  imageId?: string;
  products: Product[];
}
